class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.content = null;
    this.slotInView = true;
    this.slotObserver = null;
    this.frame = null;
    this.closingTimeout = null;
  }

  connectedCallback() {
    this.content = this.querySelector('.sticky-add-to-cart__content');
    if (!this.closest('[data-ref="product-form"]') || !this.content) return;

    this.frame = requestAnimationFrame(() => {
      // Observer l'emplacement conservé dans le formulaire, pas le bouton
      // qui devient fixe : cela évite toute boucle d'apparition/disparition.
      this.style.minHeight = `${Math.max(this.offsetHeight, 52)}px`;
      const slot = this.getBoundingClientRect();
      this.slotInView = slot.top >= 80 && slot.bottom <= window.innerHeight - 8;
      this.#updateDisplay();
      this.slotObserver = new IntersectionObserver(([entry]) => {
        this.slotInView = entry.isIntersecting && entry.intersectionRatio >= 0.99;
        this.#updateDisplay();
      }, { threshold: [0, 1], rootMargin: '-80px 0px -8px 0px' });
      this.slotObserver.observe(this);
    });
  }

  disconnectedCallback() {
    this.slotObserver?.disconnect();
    cancelAnimationFrame(this.frame);
    clearTimeout(this.closingTimeout);
  }

  #updateDisplay() {
    const shouldBeActive = !this.slotInView;
    if (shouldBeActive === (this.dataset.active === 'true')) return;
    clearTimeout(this.closingTimeout);
    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }
    this.dataset.active = 'false';
    this.dataset.closing = 'true';
    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
